import { Button } from 'primereact/button';
import { ActionCellRendererParams } from './colDefsWorkflowTable';

/**
 * Cell renderer for the select action column
 */
export const SelectCellRenderer = (props: ActionCellRendererParams) => {
  const { data, onSelect } = props;

  if (!data) {
    return null;
  }

  const handleClick = () => {
    onSelect(data);
  };

  return (
    <Button
      label="Select"
      outlined
      size="small"
      onClick={handleClick}
      className="mx-1"
    />
  );
};

export default SelectCellRenderer;
